import Row from '@ilg-totallymoney/ui/components/Row'
import Text from '@ilg-totallymoney/ui/components/Text'
import Icon from '@ilg-totallymoney/ui/icons/Icon'
import theme from '@ilg-totallymoney/ui/theme'

import RoundButton from '@components/RoundButton'

interface FilterButtonProps {
    isActivated: boolean
    onClick: () => void
}

const FilterButton = ({ isActivated = false, onClick }: FilterButtonProps) => (
    <RoundButton
        data-testid="filterButton"
        isActivated={isActivated}
        onClick={onClick}
    >
        <Row space="space10" pr="space05">
            <Icon icon="filters" color={theme.indigo60} size={24} />
            <Text variant="80" weight="bold" color="light">
                Filter
            </Text>
        </Row>
    </RoundButton>
)

export default FilterButton
